import React, { useState, useEffect } from 'react';
import TargetMonthFilter from '../../../components/DashboardTargetMonthFilter/TargetMonthFilter';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import { getBankCities, getBankList } from '../../../common/constants/api';
import {
  setFiltersInfo,
  getFiltersInfo
} from '../../../common/utils/FiltersInfo';

function ReportsTopBarFilter({
  heading,
  cityName,
  setCityName,
  bankName,
  setBankList,
  cityFilter = true,
  bankFilter = false,
  changeMonth,
  setChangeMonth,
  validRange,
  component
}) {
  const [cityOptions, setCityOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  useEffect(() => {
    getBankCities()
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        let cityList = [
          {
            value: '',
            label: <span className="text-red-100">Clear City Filter</span>
          }
        ];

        if (res instanceof Array) {
          res.map(each => {
            cityList.push({
              label: each.name,
              value: each.id
            });
          });
        }
        setCityOptions(cityList);
      })
      .catch(error => {
        setCityOptions([]);
      });
  }, []);

  useEffect(() => {
    getBankList()
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        let bankList = [
          {
            value: '',
            label: <span className="text-red-100">Clear Bank Filter</span>
          }
        ];

        if (res instanceof Array) {
          res.map(each => {
            bankList.push({
              label: each.name,
              value: each.id
            });
          });
        }
        setBankOptions(bankList);
      })
      .catch(error => {
        setBankOptions([]);
      });
  }, []);
  useEffect(() => {
    if (!bankName?.value && bankFilter)
      setBankList({
        value: '',
        label: 'Select Bank'
      });
  }, [bankName?.label]);
  useEffect(() => {
    if (!cityName?.value && setCityName)
      setCityName({
        value: '',
        label: 'Select City'
      });
  }, [cityName?.label]);

  const setNewValueInLocalStorage = (key, value) => {
    let localFilters = getFiltersInfo();
    if (typeof localFilters == 'object') {
      localFilters[key] = value;
      setFiltersInfo(localFilters);
    } else {
      setFiltersInfo({
        key: value
      });
    }
  };
  useEffect(() => {
    setNewValueInLocalStorage('targetMonth', changeMonth);
  }, [changeMonth]);

  const setCityInLocalStorage = e => {
    let city = {
      label: e.value ? e.label : 'Select City',
      value: e.value || ''
    };
    setNewValueInLocalStorage(
      component == 'TP' ? 'cityFilterTP' : 'cityFilter',
      city
    );
  };

  useEffect(() => {
    setNewValueInLocalStorage('bankFilter', bankName?.value ? bankName : '');
  }, [bankName?.value]);

  return (
    <div>
      <div className="bg-white p-6 m-3">
        <p className="text-base font-roboto font-medium text-black-1011 pb-3">
          {heading}
        </p>

        <div className="flex flex-col items-baseline sm:items-end  sm:flex-row">
          {cityFilter && (
            <CommonSelect sort={true}
              name="cityName"
              value={cityName}
              onChange={e => {
                setCityName(e);
                setCityInLocalStorage(e);
              }}
              options={cityOptions}
              dropdownStyle={{
                top: '40px',
                fontSize: '16px'
              }}
              stylesContainer={{
                height: '40px',
                width: '225px',
                marginRight: '20px'
              }}
              styleText={{
                fontSize: '14px',
                padding: '0 20px'
              }}
            />
          )}
          {bankFilter && (
            <CommonSelect sort={true}
              name="bankName"
              value={bankName}
              onChange={e => setBankList(e)}
              options={bankOptions}
              dropdownStyle={{
                top: '40px',
                fontSize: '16px'
              }}
              stylesContainer={{
                height: '40px',
                width: '225px',
                marginRight: '20px'
              }}
              styleText={{
                fontSize: '14px',
                padding: '0 20px'
              }}
            />
          )}
          <TargetMonthFilter
            setChangeMonth={e => {
              setChangeMonth(e);
            }}
            changeMonth={changeMonth}
            placeholder="Select Month"
            targetMonthRange={validRange}
            dontShowCachingData={true}
          />
        </div>
      </div>
    </div>
  );
}

export default ReportsTopBarFilter;
